(function(){
  // Delivery promise as published: ships 1–2 business days; EU up to 5, USA/Canada 8–10, Latvia 2–3; UK depends on customs.
  var P={eu:{name:'Europe',min:null,max:5},uk:null,us:{name:'the USA',min:8,max:10},ca:{name:'Canada',min:8,max:10},lv:{name:'Latvia',min:2,max:3}};
  function addBiz(d,n){d=new Date(d);while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n--;}return d;}
  var fmt=new Intl.DateTimeFormat('en-GB',{weekday:'short',day:'numeric',month:'short'});
  var today=new Date();
  function estimate(key){
    var p=P[key], ship=addBiz(today,2);
    if(!p) return {when:'Leaves by '+fmt.format(ship), note:'UK delivery time depends on customs; your tracking link shows the latest estimate. Nothing to pay at your door.', ship:fmt.format(ship), travel:'Depends on customs'};
    var late=addBiz(ship,p.max);
    return {when:p.min?fmt.format(addBiz(addBiz(today,1),p.min))+' – '+fmt.format(late):'By '+fmt.format(late), note:'Order today: it leaves Rīga by '+fmt.format(ship)+'. Nothing to pay at your door.', ship:fmt.format(ship), travel:(p.min?p.min+'–':'Up to ')+p.max+' business days'};
  }
  function flip(el){if(!el)return;el.classList.remove('flip');void el.offsetWidth;el.classList.add('flip');}
  function paint(key,anim){
    var e=estimate(key);
    document.querySelectorAll('[data-est="when"]').forEach(function(el){el.textContent=e.when;if(anim)flip(el);});
    document.querySelectorAll('[data-est="note"]').forEach(function(el){el.textContent=e.note;});
    document.querySelectorAll('[data-est="ship"]').forEach(function(el){el.textContent=e.ship;});
    document.querySelectorAll('[data-est="travel"]').forEach(function(el){el.textContent=e.travel;});
    document.querySelectorAll('select[data-ship-to]').forEach(function(s){s.value=key;});
    document.querySelectorAll('[data-place]').forEach(function(b){b.setAttribute('aria-pressed',b.dataset.place===key?'true':'false');});
  }
  document.querySelectorAll('select[data-ship-to]').forEach(function(s){s.addEventListener('change',function(){paint(s.value,true);});});
  document.querySelectorAll('[data-place]').forEach(function(b){b.addEventListener('click',function(){paint(b.dataset.place,true);});});
  var region=document.documentElement.getAttribute('data-region')||'eu';
  if(document.querySelector('[data-est]')) paint(region,false);

  // gallery
  var stage=document.getElementById('stage-img'), cap=document.getElementById('stage-cap'), tag=document.getElementById('stage-tag');
  if(stage){
    document.querySelectorAll('.thumbs button').forEach(function(b){
      b.addEventListener('click',function(){
        var im=b.querySelector('img');
        document.querySelectorAll('.thumbs button').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false');});
        stage.classList.add('fade');
        setTimeout(function(){stage.removeAttribute('srcset');stage.src=b.dataset.full||im.src;stage.alt=im.alt;stage.classList.toggle('contain',!!b.dataset.contain);if(cap)cap.textContent=b.dataset.cap||'';if(tag)tag.hidden=!b.dataset.cust;stage.classList.remove('fade');},140);
      });
    });
    // big photo: arrows, click left/right half, swipe on phones, keyboard arrows
    var tb=[].slice.call(document.querySelectorAll('.thumbs button')), box=stage.parentElement;
    if(tb.length>1&&box){
      var sx=0, sy=0, swiped=false;
      var cnt=document.createElement('span'); cnt.className='stage-count'; cnt.setAttribute('aria-hidden','true');
      var cur=function(){for(var i=0;i<tb.length;i++){if(tb[i].getAttribute('aria-pressed')==='true')return i;}return 0;};
      var upd=function(){cnt.textContent=(cur()+1)+' / '+tb.length;};
      var go=function(d){
        var i=(cur()+d+tb.length)%tb.length, t=tb[i], w=t.parentElement;
        t.click(); upd();
        if(w&&w.scrollWidth>w.clientWidth){var wr=w.getBoundingClientRect(), tr=t.getBoundingClientRect(); w.scrollTo({left:w.scrollLeft+(tr.left-wr.left)-(wr.width-tr.width)/2,behavior:'smooth'});}
        var n=tb[(i+d+tb.length)%tb.length]; if(n&&n.dataset.full){(new Image()).src=n.dataset.full;}
      };
      ['prev','next'].forEach(function(k){
        var b=document.createElement('button'); b.type='button'; b.className='stage-nav stage-'+k;
        b.setAttribute('aria-label',k==='prev'?'Previous photo':'Next photo');
        b.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+(k==='prev'?'M15 5l-7 7 7 7':'M9 5l7 7-7 7')+'"/></svg>';
        b.addEventListener('click',function(e){e.stopPropagation();go(k==='prev'?-1:1);});
        box.appendChild(b);
      });
      box.appendChild(cnt); upd();
      tb.forEach(function(b){b.addEventListener('click',function(){setTimeout(upd,0);});});
      box.addEventListener('click',function(e){if(swiped||e.target.closest('.stage-nav'))return;var r=box.getBoundingClientRect();go(e.clientX<r.left+r.width/2?-1:1);});
      box.addEventListener('touchstart',function(e){var t=e.touches[0];sx=t.clientX;sy=t.clientY;},{passive:true});
      box.addEventListener('touchend',function(e){var t=e.changedTouches[0],dx=t.clientX-sx,dy=t.clientY-sy;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.2){swiped=true;go(dx<0?1:-1);setTimeout(function(){swiped=false;},400);}},{passive:true});
      box.tabIndex=0; box.setAttribute('aria-label','Product photos. Use the left and right arrow keys to change photo.');
      box.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){go(-1);e.preventDefault();}else if(e.key==='ArrowRight'){go(1);e.preventDefault();}});
      var nx=tb[1]; if(nx&&nx.dataset.full){(new Image()).src=nx.dataset.full;}
    }
  }

  // copy email
  document.querySelectorAll('[data-copy]').forEach(function(c){
    c.addEventListener('click',function(){
      var src=document.getElementById(c.dataset.copy); if(!src)return;
      var t=src.textContent, label=c.textContent;
      function sel2(){var r=document.createRange();r.selectNodeContents(src);var s=getSelection();s.removeAllRanges();s.addRange(r);}
      try{navigator.clipboard.writeText(t).then(function(){c.textContent='Copied';setTimeout(function(){c.textContent=label;},1800);},sel2);}catch(e){sel2();}
    });
  });

  // phone buy bar
  var bar=document.getElementById('bar'), buyBtn=document.querySelector('.buy-btn');
  if(bar&&buyBtn&&'IntersectionObserver' in window){
    new IntersectionObserver(function(es){var gone=!es[0].isIntersecting&&es[0].boundingClientRect.top<0;bar.classList.toggle('on',gone);bar.setAttribute('aria-hidden',gone?'false':'true');}).observe(buyBtn);
  }

  // quantity steppers (cart)
  document.querySelectorAll('[data-qty]').forEach(function(w){
    var input=w.querySelector('input'), minus=w.querySelector('[data-step="-1"]'), plus=w.querySelector('[data-step="1"]');
    function upd(n){input.value=Math.max(1,Math.min(9,n));w.dispatchEvent(new CustomEvent('qty',{bubbles:true}));}
    minus.addEventListener('click',function(){upd((+input.value||1)-1);});
    plus.addEventListener('click',function(){upd((+input.value||1)+1);});
    input.addEventListener('change',function(){upd(+input.value||1);});
  });

  // section parts rise as they enter; they rest visible
  if(!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window){
    var els=[].slice.call(document.querySelectorAll('.rise')), vh=innerHeight;
    els.forEach(function(e){ if(e.getBoundingClientRect().top>vh) e.classList.add('pre'); });
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.remove('pre');io.unobserve(en.target);}});},{rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e,i){ e.style.transitionDelay=((i%3)*70)+'ms'; io.observe(e); });
  }

  // mobile menu
  var mb=document.querySelector('.menu-btn'), mn=document.getElementById('mnav');
  if(mb&&mn){mb.addEventListener('click',function(){var o=mn.hasAttribute('open');if(o)mn.removeAttribute('open');else mn.setAttribute('open','');mb.setAttribute('aria-expanded',o?'false':'true');});}

  // cart: a quantity change saves the cart
  var cf=document.getElementById('cartform'), ct;
  if(cf){cf.addEventListener('qty',function(){clearTimeout(ct);ct=setTimeout(function(){cf.submit();},450);});}

  // product options pick the matching variant
  var vj=document.getElementById('variants-json');
  if(vj){
    var vars=JSON.parse(vj.textContent), sels=[].slice.call(document.querySelectorAll('[data-option]')), idIn=document.querySelector('[data-variant-id]');
    var priceEl=document.querySelector('[data-price]'), label=document.querySelector('[data-buy-label]'), buy=document.querySelector('.buy-btn'), barP=document.querySelector('#bar .num');
    sels.forEach(function(s){s.addEventListener('change',function(){
      var want=sels.map(function(x){return x.value;});
      var m=vars.filter(function(v){return v.options.every(function(o,i){return o===want[i];});})[0];
      if(!m)return;
      idIn.value=m.id; if(priceEl)priceEl.textContent=m.price; if(barP)barP.textContent=m.price;
      if(buy){buy.disabled=!m.available;} if(label)label.textContent=m.available?('Add to cart, '+m.price):'Sold out';
      if(m.img&&stage){stage.classList.add('fade');setTimeout(function(){stage.removeAttribute('srcset');stage.src=m.img;stage.classList.remove('fade');},140);}
      try{var u=new URL(location.href);u.searchParams.set('variant',m.id);history.replaceState(null,'',u);}catch(e){}
    });});
  }

  // collection colour swatches
  document.querySelectorAll('[data-card]').forEach(function(card){
    var img=card.querySelector('.pic img'), name=card.querySelector('[data-swatch-name]'), idIn=card.querySelector('[data-card-variant]'), bp=card.querySelector('[data-card-btn-price]'), pr=card.querySelector('[data-card-price]');
    card.querySelectorAll('.swatches button').forEach(function(b){b.addEventListener('click',function(){
      card.querySelectorAll('.swatches button').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false');});
      if(idIn&&b.dataset.variant)idIn.value=b.dataset.variant;
      if(name)name.textContent=name.textContent.split(':')[0]+': '+b.dataset.name;
      if(bp&&b.dataset.price)bp.textContent=b.dataset.price; if(pr&&b.dataset.price)pr.textContent=b.dataset.price;
      if(img&&b.dataset.src){img.style.opacity=0;setTimeout(function(){img.removeAttribute('srcset');img.src=b.dataset.src;img.style.opacity=1;},150);}
    });});
  });

  // the reviews app adds its own widget at the end of the page; move it under our reviews
  var slot=document.getElementById('thg-reviews-slot');
  if(slot){
    var grab=function(){var w=document.getElementById('trustoo-widget-wrapper');if(w&&w.parentNode!==slot){slot.appendChild(w);return true;}return false;};
    if(!grab()&&'MutationObserver' in window){var mo=new MutationObserver(function(){if(grab())mo.disconnect();});mo.observe(document.body,{childList:true,subtree:true});setTimeout(function(){mo.disconnect();},15000);}
  }
})();
